import React, { useState, useEffect, useContext } from "react";
import "../../../ui-styles/list/AttachmentList.css";
import { LangCtx } from "../../../lib/context";
import UploadFilesListItem from "../../common/fileUploads/components/slidelistItem";
import Loader from "../../../lib/ui/loader/Loader";
import NoData from "../../../lib/ui/nodata/NoData";
import { getPatientMedicalFilesById } from "../../../actions/appointment";
import {API} from 'aws-amplify';

const PatientReports = (props) => {
    const { l } = useContext(LangCtx);
    const [loading, setLoading] = useState(false);
    const [uploaddoc, setUploaddoc] = useState([]);

    useEffect(
        () => {
             setLoading(true);
            if (props.data) {
                getPatientMedicalFilesById(props.data.patientId).then(res => {
                    setLoading(false);
                    if (res.data && res.status) {
                        setUploaddoc(res.data)
                    }
                }).catch(err => {
                    if(API.isCancel(err)) {
                        console.log("API is canceled................");
                    } else {
                        setLoading(false);
                    }
                    console.log("err in loading doctors files ==== ", err);
                })
            }
        }, [props.data.patientId]);



    return (

        <div className={props.reports ? "rightChildSlider childSliderIn" : "rightChildSlider"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.reports}</span>
                    </div>
                    <div className="hdrActionGroup" onClick={props.handleReports}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <div className="atmntContainer">
                    <div className="admntTxtCol">
                        <p className="admnTxtPara">{l.advise}: Patient Medical Uploads</p>
                        <h2 className="atmntHdngTxt">{l.attachments}</h2>
                    </div>
                    <ul className="atmntGroup">

                        {loading ? <Loader /> : uploaddoc.length > 0 ? uploaddoc.map((item, i) => <UploadFilesListItem file={item} key={`${item.key}_${i}`} access={true} />) :
                            <NoData Heading={l.no_files} src="/images/file-icons/blank-file.png" label='' />
                        }

                    </ul>
                </div>
            </div>

        </div>

    )
}
export default PatientReports;